var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.09082,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    stroke: "#EFBA00",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6540_58319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 15.5908H31.1016",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 22.0908H28.5016",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 28.5908H23.3016",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 15.5908V15.6008",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 22.0908V22.1008",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 28.5908V28.6008",
    stroke: "#E2B200",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6540_58319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(9 9.09082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoTags);
export default __webpack_public_path__ + "static/media/RoTags.a97c58d4.svg";
export { ForwardRef as ReactComponent };